export const userDataAnonymizationErrorSelector = state => state.userDataAnonymization.error;
export const isUserDataAnonymizingSelector = state => state.userDataAnonymization.isAnonymizing;
